import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { OptionContainer } from './styles';
import CheckIcon from './CheckIcon';

const OptionInput = ({
  device,
  type = 'checkbox',
  name,
  value,
  selected = false,
  onChange = () => {},
  onClick = () => {},
  label,
  flexWidth = false,
  register = () => {},
  padding = '0 16px',
  itemSelector = '',
  withTooltip = false,
  dataLabel,
  disabled = false
}) => {
  const labelRef = useRef(null);
  const [hasEllipsis, setHasEllipsis] = useState(false);

  // Función para detectar si el texto tiene ellipsis
  const checkForEllipsis = () => {
    if (labelRef.current) {
      const element = labelRef.current;
      const hasOverflow = element.offsetWidth < element.scrollWidth;
      setHasEllipsis(hasOverflow);
    }
  };

  useEffect(() => {
    checkForEllipsis();
  }, [label]);

  return (
    <OptionContainer
      data-publi={name.concat('-', dataLabel || value)}
      selected={selected}
      type={type}
      flexWidth={flexWidth}
      padding={padding}
      device={device}
      disabled={disabled}
      {...register(name)}
      className={itemSelector}
    >
      <input
        type={type}
        name={name}
        value={value}
        onChange={disabled ? () => {} : onChange}
        onClick={disabled ? () => {} : onClick}
        disabled={disabled}
      />
      <div className='input-label'>
        {withTooltip && hasEllipsis ? (
          <SimpleTooltip
            isMobile={device === 'tablet' || device === 'mobile'}
            width='200px'
            height='fit-content'
            position='bottom-center'
            text={label}
            dataPanel={`tooltip-${name}`}
            backgroundColor='#3c3834'
          >
            <span ref={labelRef}>{label}</span>
          </SimpleTooltip>
        ) : (
          <span ref={labelRef}>{label}</span>
        )}
        {type === 'checkbox' && selected && (
          <div className='check-icon'>
            <CheckIcon disabled={disabled} />
          </div>
        )}
      </div>
    </OptionContainer>
  );
};

OptionInput.propTypes = {
  device: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  flexWidth: PropTypes.bool,
  register: PropTypes.func,
  padding: PropTypes.string,
  itemSelector: PropTypes.string,
  withTooltip: PropTypes.bool,
  dataLabel: PropTypes.string,
  disabled: PropTypes.bool
};

export default OptionInput;
